import axios from 'axios';

export default axios.create({
  baseURL: 'https://improving.arlo.co/api/2012-02-01/pub/resources',
  headers: {
    Accept: 'application/json',
    // Maybe? Accept-Encoding: gzip
  },
});
